export const MinorRouteSegmentsEnum = {
  Start: 'start',
  Dashboard: 'dashboard',
  MinorsDetails: 'minors-details',
  Home: 'home',
  Subscribers: 'subscribers',
  FinancialAssets: 'financial-assets',
  BondSurety: 'bond-surety',
  Taxes: 'taxes',
  Forms: 'forms',
  Documents: 'documents',
  Notes: 'notes',
  Messages: 'messages',
  Invitation: 'invitation',
} as const;

export type MinorRouteSegments =
  (typeof MinorRouteSegmentsEnum)[keyof typeof MinorRouteSegmentsEnum];
